import { render } from "./CambiaOfferta.vue?vue&type=template&id=d35506ee&scoped=true"
import script from "./CambiaOfferta.vue?vue&type=script&lang=js"
export * from "./CambiaOfferta.vue?vue&type=script&lang=js"

import "./CambiaOfferta.vue?vue&type=style&index=0&id=d35506ee&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d35506ee"]])

export default __exports__